import { render, staticRenderFns } from "./p8.vue?vue&type=template&id=40790600&scoped=true&"
import script from "./p8.vue?vue&type=script&lang=js&"
export * from "./p8.vue?vue&type=script&lang=js&"
import style0 from "./p8.vue?vue&type=style&index=0&id=40790600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40790600",
  null
  
)

export default component.exports